/**
 * PsicoSalud — Selector de idioma (español / guaraní).
 */

import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES } from '@/i18n';

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage ?? 'es';

  return (
    <label className="t-pequeno" style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
      <span className="t-suave">{t('app.language')}</span>
      <select
        value={current}
        onChange={(event) => void i18n.changeLanguage(event.target.value)}
        aria-label={t('app.language')}
        data-cy="language-switcher"
        style={{ width: 'auto', padding: '0.3rem 0.5rem' }}
      >
        {SUPPORTED_LANGUAGES.map((language) => (
          <option key={language.code} value={language.code}>
            {language.label}
          </option>
        ))}
      </select>
    </label>
  );
}
